module.exports = __webpack_public_path__ + "img/poster.1205bbb7.png";